
<div class="login_form" v-loading="is_logging_in">
  <div class="klk_dialog_title">
    {{ $t("LOGIN_FORM_affiliate_log_in") }}
  </div>
  <p class="klk_dialog_prompt">
    {{ $t("can_log_with_klook") }}
  </p>
  <p class="error_tips" v-show="login_error !== ''">
    <span>{{ login_error }}</span>
    <span
      @click="forgot_password"
      style="cursor: pointer; text-decoration: underline; color: #f5222d"
      v-if="showResetPassword"
    >{{ $t("FORGOT_FORM_reset_password") }}</span
    >
  </p>
  <div class="klk_dialog_body">
    <klk-form :rules="formRules" :model="form_data" ref="ref_form_login">
      <klk-form-item prop="email">
        <klk-input
          :placeholder="$t('MULTIPLE_email')"
          v-on:input="login_error = ''"
          v-model.trim="form_data.email"
        ></klk-input>
      </klk-form-item>
      <klk-form-item prop="password">
        <klk-input
          :placeholder="$t('MULTIPLE_password')"
          type="password"
          v-on:input="login_error = ''"
          v-model="form_data.password"
        ></klk-input>
      </klk-form-item>

      <klk-form-item prop="affiliate_agreement">
        <klk-checkbox v-model="form_data.affiliate_agreement">
          <span
            class="affiliate_agreement"
            v-html="read_affiliate_agreement"
          ></span>
          <a
            class="theme_a"
            style="font-size: 14px"
            target="_blank"
            :href="affiliate_agreement_href"
          >
            {{ $t("LOGIN_FORM_login_affiliate_agreement") }}</a
          >
        </klk-checkbox>
      </klk-form-item>
      <klk-form-item>
        <div class="password-info-wrapper">
          <div class="remeber_me">
            <klk-checkbox v-model="form_data.remeber_me">
              {{ $t("LOGIN_FORM_remeber_me") }}
            </klk-checkbox>
          </div>
          <div class="forgot" @click="forgot_password">
            {{ $t("LOGIN_FORM_forgot_password") }}
          </div>
        </div>
      </klk-form-item>
    </klk-form>
  </div>
  <div class="klk_dialog_footer" id="klk_dialog_footer">
    <button
      id="login_btn"
      type="button"
      class="theme_btn_base btn_full log_in g-recaptcha"
      name="button"
      data-sitekey="6LdxrlUUAAAAAKenOqfrpCwQ64JncIaQ300sju2m"
      @click="captchaStart"
    >
      {{ $t("MULTIPLE_log_in") }}
    </button>
    <div class="login_ways_wrapper" v-if="!showLoginWayTips">
      <div v-for="type in loginWays" @click="comingsoon(type)">
        <klk-icon class="login_ways_icon" :type="type"></klk-icon>
      </div>
    </div>
    <div class="login_way_tips" v-else>
      {{ $t("89221") }}
    </div>
    <div class="sign_up_wrapper">
      <button type="text" class="btn_text" @click="sign_up">
        {{ $t("MULTIPLE_sign_up") }}
      </button>
    </div>
  </div>
</div>
